import React, { memo } from "react";

export const ListClinicas = memo(({ clinicas }: any) => {
     
    return clinicas?.map((value: any) => (
        
        value.$$href && value.$$title &&
        <option key={value.$$instanceId} value={value.$$title}>{value.$$title}</option>
      
    ))
});